export default {
  avatar: {
    title: "Changer d'avatar",
  },
  bindRole: {
    allServers: "Tous les Serveurs",
    bindFailed: "Échec de la liaison du personnage",
    bindSuccess: "Personnage lié",
    getRoleListFailed: "Échec du chargement de la liste des personnages",
    getServerListFailed: "Échec du chargement de la liste des serveurs",
    modifyTitle: "Changer de personnage lié",
    noRole: "Aucun personnage disponible",
    recentServers: "Votre Serveur",
    role: "Nom du personnage :",
    rolePlaceholder: "Sélectionner un personnage",
    server: "Serveur :",
    serverPlaceholder: "Sélectionner un serveur",
    title: "Lier un personnage",
  },
  commentModal: {
    placeholder: "Laisser un commentaire...",
    replyTo: "Répondre à {username}",
    title: "Commentaire",
  },
  common: {
    cancel: "Annuler",
    confirm: "OK",
    landscapeTip: "Veuillez faire pivoter votre téléphone en mode portrait pour une meilleure expérience",
    loadMore: "Glissez vers le haut pour charger plus",
    loading: "Chargement...",
    loadingMore: "Charger plus...",
    noMore: "Plus de données",
    refreshFailed: "Échec de l'actualisation",
    refreshSuccess: "Actualisé",
    submit: "Valider",
    all: "Tous",
    language: "Langue",
  },
  error: {
    50002: "Jeton invalide ou expiré",
    50006: "Pseudo déjà utilisé",
    50007: "Vous ne pouvez changer votre pseudo qu'une fois par mois, vous l'avez déjà modifié ce mois-ci",
    50008: "Points insuffisants",
    50301: "Vous n'êtes pas autorisé à publier",
    50302: "Limite de publication atteinte",
    50303: "La longueur du contenu ne répond pas aux exigences",
    50304: "Contenu inapproprié détecté. Veuillez modifier et réessayer",
    50308: "Vous n'avez pas la permission de voir cette publication",
    50309: "Message supprimé ou déplacé.",
    50351: "Sujet fermé, impossible de répondre.",
    50353: "Vous n'êtes pas autorisé à répondre",
    50354: "Réponses interdites dans cette section",
    50355: "Envoi trop fréquent, veuillez réessayer plus tard",
    50356: "Limite de publications horaires atteinte",
    50361: "Commentaire introuvable",
    50500: "Recherche indisponible pour l'instant",
    50501: "Recherche désactivée.",
    50502: "Contenu inapproprié détecté. Veuillez modifier et réessayer",
    50505: "Recherche trop fréquente, veuillez réessayer plus tard",
    50703: "Vérification de l'image échouée",
    50704: "Le contenu de l'image ne respecte pas les normes",
    50214: "Échec du partage : vous n'avez pas rejoint d'@:shareModal.alliance.",
    common: "Échec de l'opération. Veuillez réessayer plus tard.",
  },
  home: {
    gameName: "Puzzles & Survival",
    hasSigned: "Connecté",
    loginInSuccess: "Connexion réussie",
    pleaseLogin: "Veuillez d'abord vous connecter.",
    loginNow: "Connexion",
    pullToRefresh: "Tirer vers le bas pour actualiser",
    releaseToRefresh: "Relâcher pour actualiser",
    signFailed: "Échec de la connexion",
    signIn: "Connexion",
    signInFailedTip: "Échec de la connexion, veuillez réessayer ultérieurement",
    signSuccess: "Connexion réussie",
    goToShop: "Aller au Centre de Points",
    sortByLastPost: "Derniers commentaires",
    sortByTime: "Nouveautés",
    tags: {
      activity: "Événement",
      chats: "Discussion",
      guide: "Guide",
      recommend: "Recommandé",
      news: "Actualités",
    },
    unboundRole: "Personnage non lié",
  },
  linkModal: {
    close: "Close",
    textLabel: "Link Text",
    textPlaceholder: "Please enter link text",
    title: "Insert Link",
    urlLabel: "Link URL",
    urlPlaceholder: "Please enter link URL",
    viewTitle: "View Link",
  },
  maintenance: {
    title: "Maintenance en cours",
    message: "Désolé, le forum du jeu est actuellement en maintenance. Veuillez réessayer plus tard.",
  },
  mentionModal: {
    searchPlaceholder: "Rechercher un utilisateur",
    title: "Sélectionner un utilisateur",
  },
  nicknameModify: {
    alreadyRenamed:
      "Le pseudo ne peut être modifié qu'une fois par mois. Vous l'avez déjà changé ce mois-ci.",
    changedNickname: "Modifier le pseudo",
    cost: "Coût",
    date: "Date",
    getMore: "Obtenir",
    nicknameTooShort: "Le pseudo doit faire au moins 3 caractères.",
    coinNotEnough: "Points insuffisants",
    placeholder: "Veuillez saisir votre pseudo",
    recordTitle: "Historique des modifications",
    sameNickname: "Le nouveau pseudo doit être différent de l'actuel.",
    success: "Modifications enregistrées",
    viewRecord: "Historique des modifications",
  },
  notice: {
    empty: "Aucun message pour l'instant",
    likeComment: "{username} a aimé votre commentaire",
    likePost: "{username} a aimé votre publication",
    mentionComment: "{username} a mentionné votre commentaire",
    mentionPost: "{username} a mentionné votre publication",
    replyComment: "{username} a répondu à votre commentaire",
    replyPost: "{username} a commenté votre publication",
    system: "Notification système",
    tabs: {
      like: "J'aime",
      mention: "M'a mentionné",
      notification: "Notification",
      reply: "M'a répondu",
    },
    title: "Notification de message",
  },
  operateModal: {
    confirmDelete: "Voulez-vous vraiment supprimer ce message ?",
    copyFailed: "Échec de la copie",
    copyLink: "Copier le lien",
    copySuccess: "Copié",
    delete: "Supprimer",
    shareToGame: "Partager dans le jeu",
    deleteFailed: "Échec de la suppression",
    deleteSuccess: "Suppression effectuée",
    title: "Action",
  },
  shareModal: {
    selectChannelTitle: "Veuillez choisir le canal de partage",
    channelLabel: "Canal",
    channelPlaceholder: "Sélectionner un canal",
    alliance: "Alliance",
    shareSuccess: "Partage réussi",
    continueBrowse: "Continuer la navigation",
    goToGame: "Voir dans le jeu",
    noThreadTip: "Veuillez d'abord ouvrir une publication",
  },
  post: {
    create: {
      contentEmpty: "Le contenu est obligatoire",
      contentPlaceholder: "Écrivez quelque chose...",
      failed: "Échec de l'envoi",
      fileTooLarge: "Fichier trop volumineux (max {maxSize})",
      image: "Image",
      imageSizeLimit: "La taille de l'image ne doit pas dépasser 5 Mo",
      imageUploadFailed: "Impossible de charger l'image.",
      imageUploadSuccess: "Image chargée",
      imageUploading: "Chargement de l'image en cours, veuillez patienter.",
      invalidFileType: "Format de fichier non pris en charge",
      maxCharsReached: "Limite de caractères atteinte ({max} caractères)",
      mention: "{'@'}",
      selectBoard: "Sélectionner une section",
      topicLabel: "Sujet",
      submit: "Publier",
      submitting: "Envoi en cours...",
      success: "Envoyé",
      title: "Publication",
      titleEmpty: "Le titre est obligatoire",
      titlePlaceholder: "Saisir un titre",
      video: "Vidéo",
      videoSizeLimit: "La taille de la vidéo ne doit pas dépasser 50 Mo",
      videoUploadFailed: "Impossible de charger la vidéo.",
      videoUploadSuccess: "Vidéo envoyée.",
      videoUploading: "Téléchargement de la vidéo, veuillez patienter...",
    },
    title: "Publication",
  },
  postDetail: {
    allComments: "Toutes les {num} réponses",
    allReplies: "Répondre à tous",
    author: "Auteur",
    cancelFavorite: "Retiré des Favoris",
    commentTooShort: "Le commentaire doit contenir au moins 5 caractères",
    translate: "Traduire",
    translating: "Traduction en cours...",
    translateSuccess: "Traduction réussie",
    translateFailed: "Échec de la traduction",
    translatedTo: "Traduit en",
    earliest: "Réponse la plus ancienne",
    favoriteSuccess: "Ajouté aux Favoris",
    floor: "Floor",
    latest: "Réponse la plus récente",
    loadFailed: "Échec du chargement",
    noContent: "Aucun contenu",
    onlyAuthor: "Messages de l'auteur",
    reply: "Réponse",
    replyTo: "Répondre",
    sendFailed: "Échec de l'envoi",
    sendSuccess: "Envoyé",
    sending: "Envoi en cours...",
    viewOriginalPost: "Publication originale",
    writeSomething: "Parle...",
  },
  profile: {
    addLikeSuccess: "Aimé",
    cancelLikeSuccess: "Non aimés",
    communityId: "ID Communauté",
    editNickname: "Changer de pseudo",
    followSuccess: "Abonnements",
    followed: "Abonnements",
    followers: "Abonnés",
    follow: "Suivre",
    likes: "J'aime",
    noFavorites: "Aucun favori",
    noPosts: "Aucune mise à jour",
    shopLabel: "Boutique de Points",
    tabs: {
      favorites: "Mes favoris",
      posts: "Mes actualités",
    },
    title: "Profil",
    unfollowSuccess: "Désabonné",
  },
  search: {
    btn: "Recherche",
    empty: "Aucun contenu associé",
    filter: {
      dateline: "Nouveautés",
      title: "Trier",
      views: "Populaire",
    },
    historyTitle: "Historique de recherche",
    hotTitle: "Tendances",
    relatedPosts: "Publications similaires",
    tabs: {
      post: "Publication",
      user: "Utilisateur",
    },
  },
  setting: {
    about: "À propos",
    logout: "Déconnexion",
    logoutSuccess: "Déconnecté",
    privacy: "Politique de confidentialité",
    service: "Conditions d'utilisation",
    title: "Paramètres",
  },
  shop: {
    emptyTip: "Boutique en construction, restez à l'écoute",
    record: "Historique des échanges",
    title: "Centre d'échange",
    bindRole: "Lier un Personnage",
    switchRole: "Changer de personnage",
    tabs: {
      tasks: "Tâches de points",
      rewards: "Échange de récompenses",
    },
    taskInProgress: "En cours",
    taskCompleted: "Terminé",
    goToComplete: "Quête",
    exchange: "Échanger",
    exchanged: "Échangé",
    exchangeConfirmTitle: "Confirmer l'échange ?",
    currentCoins: "Points actuels",
    costCoins: "Points à consommer",
    receiveRole: "Personnage destinataire",
    exchangeSuccess: "Échange réussi",
    exchangeFailed: "Échange échoué",
  },
  exchangeRecord: {
    time: "Temps",
    content: "Contenu",
    points: "Points",
    empty: "Aucun historique d'échange",
  },
  tabBar: {
    home: "Accueil",
    notice: "Message",
    profile: "Profil",
  },
  time: {
    hoursAgo: "il y a {hours} h",
    minutesAgo: "Il y a {minutes} min",
  },
};
